"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleStats = exports.handlePrintEntries = exports.handleDiaryEntryJobs = exports.handleDiaryEntryComment = exports.handleList = exports.handleCurrent = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const currentReducer = require("./current");
const listReducer = require("./list");
const commentReducer = require("./comment");
const printReducer = require("./print");
const jobsReducer = require("./jobs");
const statsReducer = require("./stats");
exports.initialState = {
    current: Object.assign({}, currentReducer.initialState),
    list: Object.assign({}, listReducer.initialState),
    comment: Object.assign({}, commentReducer.initialState),
    print: Object.assign({}, printReducer.initialState),
    jobs: Object.assign({}, jobsReducer.initialState),
    stats: Object.assign({}, statsReducer.initialState)
};
const currentLens = monocle.Lens.fromProp('current');
const listLens = monocle.Lens.fromProp('list');
const commentLens = monocle.Lens.fromProp('comment');
const printLens = monocle.Lens.fromProp('print');
const jobsLens = monocle.Lens.fromProp('jobs');
const statsLens = monocle.Lens.fromProp('stats');
// Current
const handleCurrent = (action) => (state) => {
    const fn = currentReducer.methods[action.type];
    if (fn) {
        const current = currentLens.get(state);
        return currentLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleCurrent = handleCurrent;
// List
const handleList = (action) => (state) => {
    const fn = listReducer.methods[action.type];
    if (fn) {
        const list = listLens.get(state);
        return listLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleList = handleList;
// Comment
const handleDiaryEntryComment = (action) => (state) => {
    const fn = commentReducer.methods[action.type];
    if (fn) {
        const comments = commentLens.get(state);
        return commentLens.set(fn(comments, action))(state);
    }
    return state;
};
exports.handleDiaryEntryComment = handleDiaryEntryComment;
// Jobs
const handleDiaryEntryJobs = (action) => (state) => {
    const fn = jobsReducer.methods[action.type];
    if (fn) {
        const jobs = jobsLens.get(state);
        return jobsLens.set(fn(jobs, action))(state);
    }
    return state;
};
exports.handleDiaryEntryJobs = handleDiaryEntryJobs;
// Print
const handlePrintEntries = (action) => (state) => {
    const fn = printReducer.methods[action.type];
    if (fn) {
        const entries = printLens.get(state);
        return printLens.set(fn(entries, action))(state);
    }
    return state;
};
exports.handlePrintEntries = handlePrintEntries;
// Stats
const handleStats = (action) => (state) => {
    const fn = statsReducer.methods[action.type];
    if (fn) {
        const stats = statsLens.get(state);
        return statsLens.set(fn(stats, action))(state);
    }
    return state;
};
exports.handleStats = handleStats;
// Reducer
exports.default = (state = Object.assign({}, exports.initialState), action) => {
    return fp.function.compose((0, exports.handleCurrent)(action), (0, exports.handleList)(action), (0, exports.handleDiaryEntryComment)(action), (0, exports.handlePrintEntries)(action), (0, exports.handleDiaryEntryJobs)(action), (0, exports.handleStats)(action))(state);
};
//#endregion
//# sourceMappingURL=index.js.map